<script setup lang="ts">
import MenuDropdown from '@app/components/parts/topBar/menuDropdown.vue';
import MenuBadge, { type TopBarMenuBadgeInterface } from '@app/components/parts/topBar/menuBadge.vue';
import { isObjectEmpty } from '@/js/utils/common';
import { computed } from 'vue';
const props = withDefaults(
    defineProps<{
        open: boolean;
        menu: {
            active?: boolean;
            tabs?: [
                {
                    text: string;
                    url: string;
                    badge?: TopBarMenuBadgeInterface | null;
                    dropdown: object;
                },
            ];
        };
        sla?: {
            columns?: {
                header?: string;
                [key: string]: any;
            }[];
        };
    }>(),
    {
        menu: () => {
            return {};
        },
        sla: () => {
            return {};
        },
    },
);
function isActiveTab(section) {
    return props.menu.active === section.active;
}
function onSectionClick(e, section) {
    if (props.menu.active === section.active) {
        e.stopPropagation();
    }
}
const slaWithoutHeader = computed(() => {
    return {
        columns: props.sla.columns.map(({ header, ...rest }) => ({
            ...rest,
        })),
    };
});
</script>
<template>
    <div
        class="@[1024px]/topBar:grid-rows-1 grid w-full transition-all duration-150 ease-in-out"
        :class="props.open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
    >
        <div class="overflow-hidden">
            <div
                class="@[414px]/topBar:columns-2 @[640px]/topBar:columns-3 @[768px]/topBar:columns-4 w-full columns-1 border-t border-gray-700 bg-gray-800 pt-3"
            >
                <div
                    v-for="(section, index) in props.menu.tabs"
                    :key="index"
                    class="mb-3 inline-flex w-full flex-col"
                >
                    <component
                        :is="isActiveTab(section) ? 'strong' : 'a'"
                        :href="section.url"
                        class="font-brand flex items-center gap-1.5 px-4 text-sm font-semibold uppercase no-underline"
                        :class="
                            [
                                section.text ? '' : 'hidden @[414px]/topBar:block',
                                isActiveTab(section) ? 'text-white' : 'text-gray-500 hover:text-white',
                            ].join(' ')
                        "
                        @click="onSectionClick($event, section)"
                    >
                        <span>{{ section.text ? section.text : "&nbsp;" }}</span>
                        <MenuBadge
                            v-if="section.badge"
                            :badge="section.badge"
                            :should-load="props.open"
                            variant="tab"
                        ></MenuBadge>
                    </component>
                    <MenuDropdown
                        v-if="section.dropdown"
                        :menu="section.dropdown"
                        :in-drop-down="false"
                        :is-open="props.open"
                    ></MenuDropdown>
                </div>
                <div
                    v-if="!isObjectEmpty(props.sla)"
                    class="mb-3 inline-flex w-full flex-col"
                >
                    <div class="font-brand px-4 text-sm font-semibold uppercase text-gray-500 no-underline">
                        {{ props.sla.columns[0].header }}
                    </div>
                    <MenuDropdown
                        :menu="slaWithoutHeader"
                        :in-drop-down="false"
                        :is-open="props.open"
                    ></MenuDropdown>
                </div>
            </div>
        </div>
    </div>
</template>
